module.exports = __webpack_public_path__ + "static/mark-partners-bcf0b43cea26a6b3ba1e16791b9af920.svg";